import AsyncStorage from './AsyncStorage';

export { useAsyncStorage } from './hooks';

export type { AsyncStorageStatic } from './types';

export default AsyncStorage;
